<script>
import ThvButton from '../thv-button/ThvButton.vue'

export default {
  name: 'MenuCtaBlock',
  components: {
    ThvButton
  },
  props: {
    text: {
      type: String,
      required: true
    },
    subText: {
      type: String,
      required: true
    },
    hasImage: {
      type: Boolean,
      default: false
    },
    primaryLinkText: {
      type: String,
      required: true
    },
    primaryLinkRoute: {
      type: String,
      required: false
    },
    primaryLinkType: {
      type: String,
      required: true
    },
    secondaryLinkText: {
      type: String,
      required: false
    },
    secondaryLinkRoute: {
      type: String,
      required: false
    },
    secondaryLinkType: {
      type: String,
      required: false
    }
  },
  computed: {
    hasSecondaryLink() {
      return (
        this.secondaryLinkType &&
        this.secondaryLinkText &&
        this.secondaryLinkRoute
      )
    }
  },
  methods: {
    onLinkClick(linkTypeEvent, event) {
      this.$emit(linkTypeEvent, event)
    }
  }
}
</script>

<template lang="pug">
.menu-cta-block(:class='{ "menu-cta-block--padding": hasImage }')
  .menu-cta-block__text
    h3.heading--medium {{ text }}
    p {{ subText }}

  .menu-cta-block__buttons.sp__top--xs
    thv-button(
      :element='primaryLinkType'
      :link='primaryLinkRoute'
      @click.native='onLinkClick("primaryLinkClick", { link: primaryLinkRoute, text: primaryLinkText })'
    ) {{ primaryLinkText }}

    thv-button.menu-cta-block__buttons--secondary(
      v-if='hasSecondaryLink'
      :element='secondaryLinkType'
      :link='secondaryLinkRoute'
      type='transparent'
      @click.native='onLinkClick("secondaryLinkClick", { link: secondaryLinkRoute, text: secondaryLinkText })'
    ) {{ secondaryLinkText }}
  img.menu-cta-block__image--desktop(
    v-if='hasImage'
    src='../../assets/images/illustrations/kit-with-pill-desktop.svg'
  )
  img.menu-cta-block__image--mobile(
    v-if='hasImage'
    src='../../assets/images/illustrations/kit-with-pill-mobile.svg'
  )
</template>

<style lang="stylus" scoped>
@import '../../assets/styles/modules/*'

.menu-cta-block
  position: relative
  padding-left: 20px

  &--padding
    padding-bottom: 30%

  +media-breakpoint-up(lg)
    min-width: 425px

  &__text
    margin-top: 15px
    max-width: 80%

  &__buttons
    display: flex
    flex-direction: column

    &--secondary
      margin: 16px 0 8px 0

    +media-breakpoint-up(378px)
      flex-direction: row

      &--secondary
        margin: 0 0 0 15px

  &__image
    &--desktop
      display: none

      +media-breakpoint-up(1060px)
        display: block
        position: fixed
        left: 0
        bottom: 0
        width: 465px
        z-index: -1

    &--mobile
      display: block
      width: calc(100% + 20px)
      position: absolute
      bottom: -20px
      right: -10px

      +media-breakpoint-up(1060px)
        display: none
</style>
